import React, { useEffect, useRef } from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";

export const VideoJS = React.forwardRef((props, ref) => {
  const playerRef = useRef(null);
  const { options, onReady, onEnded, onUserActive, onUserInactive } = props;

  useEffect(() => {
    // make sure Video.js player is only initialized once
    if (!playerRef.current) {
      const videoElement = ref.current;
      if (!videoElement) return;

      const player = (playerRef.current = videojs(videoElement, options, () => {
        console.log("player is ready");
        onReady?.(player);
      }));
      onUserActive && player?.on("useractive", onUserActive);
      onUserInactive && player?.on("userinactive", onUserInactive);
    } else {
      // you can update player here [update player through props]
      const player = playerRef.current;
      player.autoplay(options.autoplay);
      player.src(options.sources);
    }
  }, [options]);

  // Dispose the Video.js player when the functional component unmounts
  useEffect(() => {
    return () => {
      if (playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, []);

  return (
    <div data-vjs-player>
      <video
        ref={ref}
        className="video-js vjs-big-play-centered"
        onEnded={onEnded}
      />
    </div>
  );
});

export default VideoJS
